import { SVGProps } from 'react';

export const MinusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path d='M2.5 6.5H9.5' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};
